import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=90e88408&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=90e88408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e88408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90e88408')) {
      api.createRecord('90e88408', component.options)
    } else {
      api.reload('90e88408', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=90e88408&scoped=true&", function () {
      api.rerender('90e88408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hpz7ha947wRJ/JS/comp/SearchFilterTokens.vue"
export default component.exports